var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgVideoElearnings = function SvgVideoElearnings(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 29H.2a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2h31.6c.11 0 .2.09.2.2v25.6a.2.2 0 0 1-.2.2M2.2 27h27.6a.2.2 0 0 0 .2-.2V5.2a.2.2 0 0 0-.2-.2H2.2a.2.2 0 0 0-.2.2v21.6c0 .11.09.2.2.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.9 14.78-9.27-5.35c-.13-.08-.3.02-.3.17v12.78c0 .15.17.25.3.17l9.27-5.35c.06-.04.1-.1.1-.17v-2.08a.22.22 0 0 0-.1-.17m-7.27-1.88 5.07 2.93c.13.08.13.27 0 .34l-5.07 2.93c-.13.08-.3-.02-.3-.17v-5.85c0-.16.17-.26.3-.18"
  })));
};
export default SvgVideoElearnings;